import { hot } from 'react-hot-loader/root';
import Component from './devicesList-redux';

export default hot(Component);
